import state from './moduleInvestorCategoryState.js'
import mutations from './moduleInvestorCategoryMutations.js'
import actions from './moduleInvestorCategoryActions.js'
import getters from './moduleInvestorCategoryGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
